import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/admin/AdminShell";
import { AdminCustomers } from "@/components/admin/customers/CustomersPage";
import { requireAdmin } from "@/lib/require-admin";

export const Route = createFileRoute("/admin_/customers")({
  beforeLoad: () => {
    requireAdmin();
  },
  component: () => (
    <AdminShell page="customers">
      <AdminCustomers />
    </AdminShell>
  ),
});
